<template>
    <div>
        <!-- Page navigation -->
        <div class="row">
            <div class="col pb-4">
                <nav class="sau-menu-horizontal md mb-4">
                    <ul>
                        <li v-for="(file, tab) in tabs" :key="tab">
                            <a href="#" data-tables-nav @click.prevent="loadComponent(tab, file), updateUrl(tab, file)" :class="{active: activeComponent === safeComponentTitle(tab)}" :title="tab">{{ tab }}</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <keep-alive>
                <component :is="activeComponent"></component>
            </keep-alive>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['components', 'target'],

    data() {
        return {
            url: '',
            panels: {},
            activeComponent: '',
            redirecting: false,
        }
    },

    created() {
        this.tabs = this.components;

        /** Check if a target has been supplied */
        this.target ? this.loadTarget() : this.loadDefault();

        /** Set the base url - minus the target if it was originally set */
        this.setBaseUrl();
    },

    methods: {
        setBaseUrl() {
            let url = window.location.href.replace(this.target, '');

            /** Trim trailing /'s */
            while (url.charAt(url.length - 1) == '/') {
                url = url.slice(0, url.length - 1);
            }

            this.url = url;
        },
        loadTarget() {
            /** Find the target to display first */
            _.forIn(this.tabs, function(val, key) {
                if (this.safeComponentTitle(key) === this.safeComponentTitle(this.target)) {
                    /** Load Component */
                    this.loadComponent(key, this.tabs[key]);
                }
            }.bind(this));

            /** load default if target doesn't exist */
            if (!this.activeComponent) {
                this.loadDefault();
            }
        },
        updateUrl(tab, file) {
            if(this.justRedirectToTheActualUrl(file)) return;

            let append = this.safeComponentTitle(tab);
            /** Check that we aren't doubling up in the url - services/services etc */
            this.url.indexOf(append) > 0 ? history.pushState({}, append, this.url) : history.pushState({}, append, this.url + '/' + append);
        },
        loadDefault() {
            /** Set first entry to be active component, and ensure it is not the observer (for Safari) */
            let keys = Object.getOwnPropertyNames(this.tabs).filter(k => k !== '__ob__');
            this.loadComponent(keys[0], this.tabs[keys[0]]);
        },
        loadComponent(tab, file) {
            if(this.justRedirectToTheActualUrl(file)) return;

            let safeTitle = this.safeComponentTitle(tab);
            // Vue.component(safeTitle, () => import(`@js/components/${file}`));
            Vue.component(
                safeTitle,
                resolve => resolve(require(`@js/components/${file}`)))

            this.activeComponent = safeTitle

        },
        safeComponentTitle(tab) {
            /** Replace whitespace with - */
            return tab.replace(/[\s]/g, "-").toLowerCase();
        },

        justRedirectToTheActualUrl(componentPath)
        {
            if(this.redirecting  || ! this.ignoreList.hasOwnProperty(componentPath)) return false;
            this.redirecting = true;
            window.location = this.ignoreList[componentPath];
            return true; // Return here so we don't load the other code
        }
    },
    computed: {
        ignoreList() {
            return {
                'account/PaymentMethodsMain': '/account/payment-options'
            };
        },
    }
}
</script>

<style lang="scss" scoped>
    /*.sau-menu-horizontal {
        border-bottom: 1px solid #e5e5e5;
    }*/
    .sau-menu-horizontal ul li {
        display: inline-block;
    }
</style>
